import { createTheme } from './createTheme';
export var FluentTheme = createTheme({});
//# sourceMappingURL=FluentTheme.js.map